import React, { useMemo, useState } from 'react';
import { ReferenceMarkup } from './ReferenceMarkup';
import { createReferenceViews } from './referenceViews';

export const Calculator = ({ mode, lang }) => {
  const flower = mode === 'flower';
  const [quantity, setQuantity] = useState(flower ? 5 : 100);
  const [rate, setRate] = useState(flower ? 15000 : 500);
  const views = useMemo(() => createReferenceViews(lang), [lang]);
  const tr = (mr, en) => lang === 'mr' ? mr : en;
  const money = n => '₹' + n.toLocaleString('en-IN');
  const input = (value, setter) => () => ({ props: { value, defaultValue: undefined, onChange: e => setter(Number(e.target.value)) } });
  return <ReferenceMarkup html={views.calculator(mode)} prefix={`calculator-${mode}`} tr={tr} overrides={{
    qty: input(quantity, setQuantity), rate: input(rate, setRate),
    'qty-val': () => ({ children: quantity }), 'rate-val': () => ({ children: money(rate) }),
    total: () => ({ children: money(quantity * rate) }), formula: () => ({ children: `${quantity} × ${money(rate)}` }),
  }} />;
};